import script from "./BusinessHoursSelection.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinessHoursSelection.vue?vue&type=script&lang=ts&setup=true"

import "./BusinessHoursSelection.vue?vue&type=style&index=0&id=19616b05&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19616b05"]])

export default __exports__